import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const votePackageService = {
    /**
     * Get all vote packages
     */
    getAllPackages: async () => {
        try {
            const response = await axios.get(`${API_URL}/vote-packages`, {
                headers: getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Get a single vote package by ID
     */
    getPackageById: async (packageId) => {
        try {
            const response = await axios.get(`${API_URL}/vote-packages/${packageId}`, {
                headers: getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Create a new vote package
     */
    createPackage: async (packageData) => {
        try {
            const response = await axios.post(`${API_URL}/vote-packages`, packageData, {
                headers: getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Update an existing vote package
     */
    updatePackage: async (packageId, packageData) => {
        try {
            const response = await axios.put(`${API_URL}/vote-packages/${packageId}`, packageData, {
                headers: getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Toggle package status (active/inactive)
     */
    togglePackageStatus: async (packageId, isActive) => {
        try {
            const response = await axios.patch(`${API_URL}/vote-packages/${packageId}/status`, 
                { isActive },
                {
                    headers: getAuthHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Delete a vote package
     */
    deletePackage: async (packageId) => {
        try {
            const response = await axios.delete(`${API_URL}/vote-packages/${packageId}`, {
                headers: getAuthHeaders(),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};
